module.exports = __webpack_public_path__ + "static/Trans-6-Clean-9b235a75c703362452e7d011a394038e.svg";